import { useEffect } from 'react';
import { useSiteConfig } from '../../context/SiteConfigContext';
import { initAnalytics, setAnalyticsMeasurementId } from '../../lib/analytics';
import { getCookieConsentService } from '../../privacy/cookie/CookieConsentService';

export default function AnalyticsInit() {
  const { site, loaded } = useSiteConfig();

  useEffect(() => {
    if (!loaded) return;
    const id = site.integrations.gaMeasurementId || import.meta.env.VITE_GA_MEASUREMENT_ID || '';
    setAnalyticsMeasurementId(id);
    if (id && getCookieConsentService().isCategoryEnabled('analytics')) {
      initAnalytics();
    }
  }, [loaded, site.integrations.gaMeasurementId]);

  return null;
}
